import { type ExporterColumn, type ExportProgress } from '@webapp/models'
import { type ExportType } from '@webapp/models/enums'
import { type ExportFormat } from '@webapp/platform/_unmigrated/Exporter/types'
import { ApiClient } from '@webapp/services/api'

export const ENDPOINT = '/api/v3/export-formats/'
export const EXPORTER_URL = ENDPOINT

export interface ExportSampleResponseMetadata {
  permissions: unknown
  summary: {
    has_multiple_currency: boolean
    total_cost: number
  }
}

export const ExporterAPI = {
  getExportFormats: (params) => {
    return ApiClient.get<ExportFormat[]>(`${EXPORTER_URL}`, { params })
  },
  getExportSample: (endpoint: string, params) => {
    return ApiClient.get<string[][], string[][], ExportSampleResponseMetadata>(
      `${endpoint}export-sample/`,
      {
        params,
      }
    )
  },
  getExportColumns: (endpoint: string) => {
    return ApiClient.get<Omit<ExporterColumn, 'active'>[]>(
      `${endpoint}export-columns/`
    )
  },
  updateExportFormat: (formatId: number, data: ExportFormat) => {
    return ApiClient.put<ExportFormat, ExportFormat>(
      `${EXPORTER_URL}${formatId}/`,
      data
    )
  },
  createExportFormat: (data: Omit<ExportFormat, 'id' | 'is_default'>) => {
    return ApiClient.post<
      Omit<ExportFormat, 'id' | 'is_default'>,
      ExportFormat
    >(`${EXPORTER_URL}`, data)
  },
  setDefaultFormatOption: (formatId: number) => {
    return ApiClient.patch<any, ExportFormat>(`${EXPORTER_URL}${formatId}/`, {
      is_default: true,
    })
  },
  deleteDefaultFormatOption: (type: ExportType) => {
    return ApiClient.delete(`${EXPORTER_URL}default/`, {
      params: {
        type,
      },
    })
  },
  deleteFormatOption: (formatId: number) => {
    return ApiClient.delete(`${EXPORTER_URL}${formatId}/`)
  },
  export: (endpoint: string, data, config = {}) => {
    return ApiClient.post<any, ExportProgress>(
      `${endpoint}export/`,
      data,
      config
    )
  },
}
